/* ==========================================================================
   FRØYA GOURMET — bevegelse: myk scroll, parallakse, fremvekst, chatboble

   0) EGEN ANIMASJONSKLOKKE (22.10.2026). Regneffekten i heroen bremser
      window.requestAnimationFrame til ~30 bilder/s mens regnet går (bevisst,
      se froya-hero.liquid). Myk scroll og parallakse bruker derfor
      fgMotionRAF, fanget HELT øverst før regnet rekker å starte.

   1) MYK SCROLL (Lenis 1.1.18, MIT) — KUN mus/styreflate (hover: hover +
      pointer: fine). Telefon/nettbrett beholder native scrolling, uendret.

      01.11.2026: slått AV i v25–v28, og PÅ igjen i v29 (Thom foretrakk følelsen
      med myk scroll; native scroll føltes raskere og mindre jevn). Blur-fjerningen
      fra flyt.css beholdes. Handlekurv-fiksen (resize() i froya-levering-datoer)
      holder rullegrensen riktig. Skru av: sett MYK_SCROLL = false.

      1.12 (01.11.2026): styreflate ble nativ på HELE siden for å fjerne «drar og
      hakker» i handlekurven. Thom: forsiden mistet det luksuriøse, myke preget.
      1.14: myk scroll (lerp 0.13, som v29) for mus OG styreflate på alle sider,
      UNNTATT handlekurven (/cart): der går styreflaten nativt (ingen dobbel
      treghet oppå macOS sin), og mushjulet får litt kortere hale (lerp 0.16).
      Skru av kurv-unntaket: sett KURV_NATIV = false.
      (August-versjonen hadde lerp 0.08 og ble avvist som «WAY too slow» —
      ikke gå under ~0.12.)

      VIKTIG — LASTING: lenis.min.js 1.1.18 er et klassisk skript som
      deklarerer hjelpefunksjonene sine (k, w, W, z, x, y …) som GLOBALE
      variabler. Et annet skript på siden har allerede en global «w», så en
      vanlig <script src> ga «w is not a function» og siden lot seg ikke
      scrolle med hjulet. Derfor: filen hentes med fetch() + SRI-sjekk
      (integrity), og kjøres inne i en egen funksjon (new Function), der alle
      var-deklarasjoner blir lokale. Kun window.Lenis eksponeres.
      Feiler noe (CDN, SRI, parse): vanlig native scroll, ingenting brekker.

   2) Fremvekst: IntersectionObserver legger til .is-revealed én gang.
   3) Parallakse: aktive lag oppdateres én gang per ramme på fgMotionRAF.
   4) Chatboble-tilstand som klasser på <html> (.fg-sticky-synlig,
      .fg-meny-apen) — erstatter html:has(...).

   prefers-reduced-motion: reduce slår av myk scroll, fremvekst og parallakse.
   ========================================================================== */

var fgMotionRAF = window.requestAnimationFrame.bind(window);

/* --- 1) Myk scroll -------------------------------------------------------- */
(function () {
  'use strict';

  var MYK_SCROLL = true;
  var KURV_NATIV = true;
  var KURV = KURV_NATIV && location.pathname.indexOf('/cart') === 0;
  var LERP = KURV ? 0.16 : 0.13;
  var URL = 'https://cdn.jsdelivr.net/npm/lenis@1.1.18/dist/lenis.min.js';
  var SRI = 'sha384-tKsJDT6PlUI0pSBt9/sBKJluKgA19/a6mBrDsZaXotLB4ZYfMGM6xt6/WgGpYhTm';
  var NL = String.fromCharCode(10);

  if (!MYK_SCROLL) return;
  var mm = window.matchMedia;
  if (!mm) return;
  if (mm('(prefers-reduced-motion: reduce)').matches) return;
  if (!mm('(hover: hover) and (pointer: fine)').matches) return;
  if (!window.fetch) return;

  /* --- Styreflate-gjenkjenning (brukes bare i handlekurven) --------------- */
  var styreflate = false;
  var sistHjul = 0;
  var sistVarSF = false;

  function erStyreflate(e) {
    if (e.deltaMode !== 0) return false;                 /* linjer/sider = mushjul */
    if (e.deltaX !== 0) return true;                     /* sideveis bevegelse = styreflate */
    var wy = e.wheelDeltaY;
    if (typeof wy === 'number' && wy !== 0) {
      if (wy === -3 * e.deltaY) return true;             /* Chrome/Edge/Safari: styreflate */
      if (wy % 120 === 0) return false;                  /* klassisk mushjul-hakk */
    }
    return e.deltaY % 1 !== 0 || Math.abs(e.deltaY) < 16; /* små/brøk-steg = styreflate */
  }

  if (KURV) {
    /* Kjører FØR Lenis (capture på window). Rører ikke hendelsen, setter bare et flagg. */
    window.addEventListener('wheel', function (e) {
      var na = performance.now();
      var sf = erStyreflate(e);
      if (!sf && sistVarSF && na - sistHjul < 140) sf = true;
      styreflate = sf;
      sistVarSF = sf;
      sistHjul = na;
      var l = window.__fgLenis;
      if (sf && l && l.isScrolling === 'smooth') {
        try { l.scrollTo(l.rootElement ? l.rootElement.scrollTop : l.actualScroll, { immediate: true }); } catch (err) {}
      }
    }, { capture: true, passive: true });
  }

  function lastLenis() {
    if (typeof window.Lenis === 'function') return Promise.resolve(window.Lenis);
    return fetch(URL, { integrity: SRI, mode: 'cors', credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('lenis ' + r.status);
        return r.text();
      })
      .then(function (src) {
        src = src.replace(new RegExp('//# sourceMappingURL=.*$', 'm'), '');
        /* Egen funksjons-scope: k, w, W, z, x, y … blir lokale. */
        var Klasse = (new Function(src + NL + ';return globalThis.Lenis;'))();
        if (typeof Klasse !== 'function') throw new Error('lenis mangler');
        return Klasse;
      });
  }

  function start() {
    var wrapper = document.querySelector('.page-wrapper');
    if (!wrapper || window.__fgLenis) return;

    lastLenis().then(function (Lenis) {
      var stil = document.createElement('style');
      stil.textContent = '.lenis.lenis-smooth{scroll-behavior:auto!important}' +
        '.lenis.lenis-smooth [data-lenis-prevent]{overscroll-behavior:contain}';
      document.head.appendChild(stil);

      var lenis = new Lenis({
        wrapper: wrapper,
        content: wrapper,
        lerp: LERP,
        smoothWheel: true,
        syncTouch: false,
        wheelMultiplier: 1,
        autoRaf: false,
        prevent: function (node) {
          /* Handlekurv + styreflate: la nettleseren scrolle selv. */
          if (KURV && styreflate) return true;
          return !!(node && node.closest && node.closest(
            '#fg-faqbot, dialog, cart-drawer, .fg-header__drawer, ' +
            '[data-lenis-prevent], .predictive-search, .search-modal, ' +
            '[role="dialog"]'
          ));
        }
      });
      window.__fgLenis = lenis;

      function ramme(t) {
        lenis.raf(t);
        fgMotionRAF(ramme);
      }
      fgMotionRAF(ramme);

      /* Mobilmeny åpen = sidens scroll låst: stopp Lenis. */
      var root = document.documentElement;
      new MutationObserver(function () {
        if (root.classList.contains('fg-meny-apen')) lenis.stop();
        else lenis.start();
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
    }).catch(function (e) {
      if (window.console) console.warn('froya myk scroll av (native scroll brukes):', e);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* --- 4) Chatboble-tilstand ------------------------------------------------- */
(function () {
  'use strict';

  var root = document.documentElement;

  function folg(el, attr, test, klasse) {
    if (!el) return;
    var forrige = null;
    function sjekk() {
      var na = test(el);
      if (na === forrige) return;
      forrige = na;
      root.classList.toggle(klasse, na);
    }
    sjekk();
    new MutationObserver(sjekk).observe(el, { attributes: true, attributeFilter: attr });
  }

  function start() {
    folg(
      document.querySelector('.sticky-add-to-cart__bar'),
      ['data-stuck'],
      function (el) { return el.getAttribute('data-stuck') === 'true'; },
      'fg-sticky-synlig'
    );
    folg(
      document.querySelector('[data-fg-drawer]'),
      ['hidden', 'class'],
      function (el) { return !el.hidden; },
      'fg-meny-apen'
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* --- 2) Fremvekst og 3) parallakse ----------------------------------------- */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var revealEls = document.querySelectorAll('[data-fg-reveal]');

  if (!revealEls.length) {
    // ingenting å gjøre
  } else if (reduceMotion || !('IntersectionObserver' in window)) {
    for (var i = 0; i < revealEls.length; i++) revealEls[i].classList.add('is-revealed');
  } else {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }

  if (reduceMotion || !('IntersectionObserver' in window)) return;

  var parallaxNodes = document.querySelectorAll('[data-fg-parallax]');
  if (!parallaxNodes.length) return;

  var layers = Array.prototype.map.call(parallaxNodes, function (el) {
    var range = parseFloat(el.getAttribute('data-fg-parallax-range'));
    return { el: el, range: isNaN(range) ? 28 : range, active: false, sist: null };
  });

  var byEl = new Map();
  layers.forEach(function (l) { byEl.set(l.el, l); });

  var parallaxObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var layer = byEl.get(entry.target);
        if (layer) layer.active = entry.isIntersecting;
      });
    },
    { rootMargin: '20% 0px 20% 0px' }
  );
  layers.forEach(function (l) { parallaxObserver.observe(l.el); });

  var vh = window.innerHeight;
  window.addEventListener(
    'resize',
    function () { vh = window.innerHeight; },
    { passive: true }
  );

  var ticking = false;
  function oppdaterLag() {
    ticking = false;
    for (var i = 0; i < layers.length; i++) {
      var layer = layers[i];
      if (!layer.active) continue;
      var rect = layer.el.getBoundingClientRect();
      var progress = (vh - rect.top) / (vh + rect.height);
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      var px = ((progress - 0.5) * layer.range).toFixed(1);
      if (px === layer.sist) continue;
      layer.sist = px;
      layer.el.style.setProperty('--fg-parallax-y', px + 'px');
    }
  }

  oppdaterLag();
  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      fgMotionRAF(oppdaterLag);
    },
    { passive: true, capture: true }
  );
})();